export default __webpack_public_path__ + "static/media/acceso_perfiles_ilus3.80220b63.svg";